import React from 'react';

/**
 * Consistent panel shell for account sections.
 */
export default function AccountCard({ id, title, lead, children, className = '', as: Tag = 'section' }) {
  return (
    <Tag className={`account-card ${className}`.trim()} aria-labelledby={id ? `${id}-heading` : undefined}>
      {title ? (
        <header className="account-card__head">
          <h2 id={id ? `${id}-heading` : undefined} className="account-card__title">
            {title}
          </h2>
          {lead ? <p className="account-card__lead">{lead}</p> : null}
        </header>
      ) : null}
      <div className="account-card__body">{children}</div>
    </Tag>
  );
}
